module.exports = __webpack_public_path__ + "res/img/error.e061eba0.png";